import React, { Fragment } from "react"
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./Gallery.css";

import food from "../images/bb_food.jpg";
import kids from "../images/bb_kids.JPEG";
import art from "../images/bb_art.JPEG";
import clothes from "../images/bb_clothes.JPEG";
import backpacks from "../images/bb_backpacks.jpg";

import bengali from '../images/bb_bengali.JPEG';
import math from '../images/bb_math.JPEG';
import science from '../images/bb_science.JPEG';
import globalstudies from '../images/bb_globalstudies.jpg';
import additional from '../images/bb_additional.JPEG';


import learning from '../images/bb_learning.JPEG'; 
import classenvironment from '../images/bb_classenvironment.JPEG';

import heroImg from '../images/bb_classroom.JPEG'; 

import heroImg2 from '../images/brightbeginning_bigbanner.JPEG'; 

import heroImg3 from '../images/bb_aboutbanner.JPEG'; 

import banner1 from '../images/bb_banner.png'; 
import banner2 from '../images/bb_banner2.png'; 

import banner3 from '../images/aboutbanner.JPG';



import english from '../images/English.jpg';
import bangla from '../images/Bangla.jpg';
import classroomenvironment from '../images/classroomenvironment.jpg';
import holistic from '../images/holistic.jpg';
import meals from '../images/nutritiousmeals.jpg';
import parents from '../images/parents.jpeg';



import carromGame from "../images/Carrom Game.jpg";
import puzzleGame from "../images/Pazzle Game.jpg";
import artCraftBoys from "../images/Art & Craft Boys.jpeg";
import dsc03722 from "../images/DSC03722.JPG";
import dsc03803 from "../images/DSC03803.JPG";
import img6761 from "../images/IMG_6761.jpg";
import img4992 from "../images/IMG_4992.jpg";
import img5367 from "../images/IMG_5367.JPG";
import img1887 from "../images/IMG_1887.jpg";
import img5120 from "../images/IMG_5120.JPG";
import img5557 from "../images/IMG_5557.JPG";
import img5657 from "../images/IMG_5657.JPG";
import img6659 from "../images/IMG_6659.JPG";
import uuid1 from "../images/2d0ee9e7-0e2d-42b6-97a0-8e6a1adaf7ed.jpg";
import uuid2 from "../images/a943654c-c37f-4181-b8c5-075026485531.jpg";
import uuid3 from "../images/b378695c-61c4-45c0-9a79-bd751902db62.jpg";


const images = [
  { src: food, alt: "Lunch" },
  { src: kids, alt: "Students" },
  { src: art, alt: "Art Class" },
  { src: clothes, alt: "Clothing Drive" },
  { src: backpacks, alt: "Free Backpacks" },

  
  { src: banner1, alt: "Home Banner" },
  { src: banner2, alt: "Contact Banner" },
  
  { src: banner3, alt: "About Banner" },

  { src: bengali, alt: "Bengali Class" },
  { src: math, alt: "Math Class" },
  { src: science, alt: "Science Class" },
  { src: globalstudies, alt: "Global Studies Class" },
  { src: additional, alt: "Additional Learning" },

  { src: learning, alt: "Learning Session" },

  { src: classenvironment, alt: "Classroom Environment" },

  

  { src: heroImg, alt: "Hero Image 1" },
  { src: heroImg2, alt: "Hero Image 2" },
  { src: heroImg3, alt: "Hero Image 3" },


  { src: english, alt: "English Class" },
  { src: bangla, alt: "Bangla Class" },
  { src: classroomenvironment, alt: "Classroom Environment" },
  { src: holistic, alt: "Holistic Learning" },
  { src: meals, alt: "Nutritious Meals" },
  { src: parents, alt: "Parents Involvement" },


  { src: carromGame, alt: "Carrom Game" },
  { src: puzzleGame, alt: "Puzzle Game" },
  { src: artCraftBoys, alt: "Art & Craft Boys" },
  { src: dsc03722, alt: "Classroom Activity" },
  { src: dsc03803, alt: "Student Work" },
  { src: img6761, alt: "Campus View" },
  { src: img4992, alt: "Group Activity" },
  { src: img5367, alt: "Learning Materials" },
  { src: img1887, alt: "School Event" },
  { src: img5120, alt: "Student Portrait" },
  { src: img5557, alt: "Workshop" },
  { src: img5657, alt: "Playtime" },
  { src: img6659, alt: "Indoor Games" },
  { src: uuid1, alt: "Additional Activity 1" },
  { src: uuid2, alt: "Additional Activity 2" },
  { src: uuid3, alt: "Additional Activity 3" },

];

export default function Gallery() {
  return (
    <Fragment>
        <div className="gallery-title-card">
            <h1>Photo Gallery</h1>
            <p>Moments from our school’s activities, events, and learning experiences</p>
        </div>
        
        <div className="gallery">
        {images.map((image, index) => (
            <div key={index} className="gallery-item">
            <LazyLoadImage
                src={image.src}
                alt={image.alt}
                effect="blur"
                width="100%"
            />
            </div>
        ))}
        </div>
    </Fragment>
    
  );
}
